module.exports = __webpack_public_path__ + "img/swap-token.e38c3256.svg";